export function closeBanner() {
  return {
    type: '@appBanner/CLOSE_APP_BANNER',
  };
}
